import LegalLayout from './LegalLayout'

function TermsConditions() {
    return (
        <LegalLayout title="Términos y Condiciones de Uso" subtitle="Factur 24/7">
            <section className="legal-section">
                <p>
                    <strong>Entrada en vigor: 1 de junio de 2025</strong>
                </p>
                <h2>1. Aceptación</h2>
                <p>
                    Al registrarse en la aplicación <strong>Factur 24/7</strong>, el usuario acepta estos Términos y Condiciones,
                    así como la{' '}
                    <a href="https://factur247.com/politicas_de_privacidad" rel="noreferrer noopener">
                        Política de Privacidad
                    </a>
                    . Si no está de acuerdo con alguno de los términos, debe abstenerse de utilizar la aplicación.
                </p>
            </section>

            <section className="legal-section">
                <h2>2. Objeto del Servicio</h2>
                <p>
                    Factur 24/7 es una plataforma digital que permite a personas naturales y jurídicas emitir comprobantes
                    electrónicos (facturas, notas de crédito, etc.) conforme a la normativa del <strong>Servicio de Rentas
                        Internas (SRI)</strong> del Ecuador.
                </p>
                <p>
                    <strong>Importante:</strong> Factur 24/7 <strong>no es un Proveedor Autorizado de Comprobantes (PAC)</strong>
                    ni representa legalmente al usuario ante el SRI.
                </p>
            </section>

            <section className="legal-section">
                <h2>3. Registro y Cuenta de Usuario</h2>
                <p>
                    Para utilizar el servicio, el usuario debe registrarse proporcionando datos verídicos como: nombre, RUC,
                    correo electrónico y teléfono.
                </p>
                <p>El usuario:</p>
                <ul>
                    <li>Es responsable de la veracidad de la información entregada.</li>
                    <li>Debe proteger la confidencialidad de sus credenciales.</li>
                    <li>Es responsable del uso que se haga con su cuenta.</li>
                </ul>
            </section>

            <section className="legal-section">
                <h2>4. Tratamiento de Datos Personales</h2>
                <p>
                    Al registrarse, el usuario autoriza expresamente el tratamiento de sus datos personales (nombre, RUC, email,
                    teléfono) para las siguientes finalidades:
                </p>
                <ol>
                    <li>Emitir comprobantes electrónicos (obligación legal).</li>
                    <li>Gestionar su cuenta y proveer soporte técnico.</li>
                    <li>
                        Enviar comunicaciones informativas o promocionales, <strong>sólo si el usuario ha dado su consentimiento
                            adicional</strong>.
                    </li>
                </ol>
                <p>El usuario puede ejercer sus derechos ARCO contactando al Delegado de Protección de Datos:</p>
                <ul>
                    <li>
                        <strong>Correo electrónico:</strong>{' '}
                        <a href="mailto:protecciondatos@factur247.com">protecciondatos@factur247.com</a>
                    </li>
                </ul>
            </section>

            <section className="legal-section">
                <h2>5. Licencia de Uso</h2>
                <p>
                    Factur 24/7 otorga al usuario una <strong>licencia limitada, revocable, no exclusiva e intransferible</strong>
                    para usar la aplicación según estos términos. No se permite:
                </p>
                <ul>
                    <li>Copiar, modificar o distribuir la aplicación sin autorización.</li>
                    <li>Usar la app para fines ilícitos, fraudulentos o que vulneren la ley ecuatoriana.</li>
                </ul>
            </section>

            <section className="legal-section">
                <h2>6. Responsabilidades y Limitaciones</h2>
                <p>Factur 24/7 no se responsabiliza por:</p>
                <ul>
                    <li>Errores en la información ingresada por el usuario.</li>
                    <li>Fallas técnicas externas a la aplicación (como problemas en los servidores del SRI).</li>
                    <li>Pérdida de información causada por mal uso del sistema o violación de estos términos.</li>
                </ul>
                <p>El usuario es el único responsable de cumplir con sus obligaciones tributarias.</p>
            </section>

            <section className="legal-section">
                <h2>7. Modificaciones y Actualizaciones</h2>
                <p>
                    Estos Términos pueden ser actualizados en cualquier momento. Los cambios serán notificados en la aplicación y
                    entrarán en vigencia 7 días después de su publicación. El uso continuado de la aplicación implica la
                    aceptación de las modificaciones.
                </p>
            </section>

            <section className="legal-section">
                <h2>8. Suspensión y Cancelación</h2>
                <p>Factur 24/7 podrá suspender temporal o permanentemente el acceso del usuario si:</p>
                <ul>
                    <li>Se detecta uso fraudulento o ilegal.</li>
                    <li>Se incumplen estos Términos o la Política de Privacidad.</li>
                    <li>Hay inactividad prolongada superior a 12 meses.</li>
                </ul>
                <p>El usuario puede cancelar su cuenta solicitándolo mediante el formulario web oficial o mediante la app.</p>
            </section>

            <section className="legal-section">
                <h2>9. Legislación Aplicable</h2>
                <p>Este documento se rige por la legislación de la <strong>República del Ecuador</strong>, incluyendo:</p>
                <ul>
                    <li>Ley Orgánica de Protección de Datos Personales.</li>
                    <li>Ley de Comercio Electrónico, Firmas Electrónicas y Mensajes de Datos.</li>
                    <li>Código Tributario.</li>
                </ul>
            </section>

            <section className="legal-section">
                <h2>10. Resolución de Conflictos</h2>
                <h3>10.1 Mediación</h3>
                <p>
                    Se buscará primero una solución amistosa mediante mediación, administrada por el <strong>Centro de Arbitraje y
                        Mediación de la Cámara de Comercio de Loja</strong>.
                </p>
                <h3>10.2 Arbitraje</h3>
                <p>
                    Si no se alcanza un acuerdo en 30 días, el conflicto será resuelto mediante <strong>arbitraje en derecho</strong>,
                    también ante el mismo Centro:
                </p>
                <ul>
                    <li>Resuelto por un árbitro único.</li>
                    <li>De carácter confidencial.</li>
                    <li>Ejecutable sin recurrir a juzgados ordinarios.</li>
                </ul>
            </section>
        </LegalLayout>
    )
}

export default TermsConditions
